import axios from "axios";
import { API_BASE_URL } from "configs/AppConfig";
import { signOutSuccess } from "store/slices/authSlice";
import store from "../store";
import { AUTH_TOKEN, USER } from "constants/AuthConstant";
import { notification } from "antd";

const unauthorizedCode = [400, 401, 403];

const service = axios.create({
  baseURL: API_BASE_URL,
  timeout: 60000,
});

// Config
const TOKEN_PAYLOAD_KEY = "Authorization";

// API Request interceptor
service.interceptors.request.use(
  (config) => {
    const jwtToken = localStorage.getItem(AUTH_TOKEN) || null;

    if (jwtToken) {
      config.headers[TOKEN_PAYLOAD_KEY] = `Bearer ${jwtToken}`;
    }

    return config;
  },
  (error) => {
    // Do something with request error here
    notification.error({
      message: "Error",
    });
    return Promise.reject(error);
  }
);

// API response interceptor
service.interceptors.response.use(
  (response) => {
    if (response.config.responseType === "blob") {
      return response;
    }
    response.data.statusCode = response.status;

    return response.data;
  },
  (error) => {
    let notificationParam = {
      message: "",
    };
    if (error.response) {
      if (unauthorizedCode.includes(error.response.status)) {
        notificationParam.message =
          error.response.data.message || "Unauthorized";
        notificationParam.description = "Please login again";
        // Handle invalid uname password
        if (error.response.config.url.split("/").pop() === "login") {
          notificationParam.message =
            error.response.data.message || "Invalid username or password";
        }
        localStorage.removeItem(AUTH_TOKEN);
        localStorage.removeItem(USER);
        store.dispatch(signOutSuccess());
      }

      if (error.response.status === 404) {
        notificationParam.message = "Not Found";
      }

      if (error.response.status === 500) {
        notificationParam.message = "Internal Server Error";
      }

      if (error.response.status === 508) {
        notificationParam.message = "Time Out";
      }

      notification.error(notificationParam);
    } else {
      if (error.code === "ERR_NETWORK") {
        notificationParam.message = "No Internet Connection";
        notificationParam.description =
          "Please check your network and try again.";
        notification.error(notificationParam);
        return Promise.reject(new Error("No internet connection."));
      }
      //only response header is coming in case of invalid token so handled it here

      // notificationParam.message = "Token Invalid";
      error.message = "Token Invalid.Please login again";
      // notification.error(notificationParam);
      localStorage.removeItem(AUTH_TOKEN);
      localStorage.removeItem(USER);
      store.dispatch(signOutSuccess());
    }
    return Promise.reject(error);
  }
);

export default service;
